<template>
  <div class="home">
    <!-- <mt-popup
      v-model="popupVisible"
      :modal="true"
      position="right"
     >
      <ul class="popupList">
        <li>
          <span>首页</span>
          <span>Home</span>
        </li>
        <li>
          <span>集团概况</span>
          <span>Group overview</span>
        </li>
        <li>
          <span>产业链及子公司</span>
          <span>Industrial Chain and Subsidiaries</span>
        </li>
        <li>
          <span>产品及下载</span>
          <span>Products and DownLoads</span>
        </li>
        <li>
          <span>企业文化</span>
          <span>Corporate Culture</span>
        </li>
        <li>
          <span>合作伙伴</span>
          <span>Cooperative Partner</span>
        </li>
        <li>
          <span>联系我们</span>
          <span>Contact Us</span>
        </li>
        <li>
          <span>信息披露</span>
          <span>Information Disclosure</span>
        </li>
      </ul>
    </mt-popup> -->
    <!-- 头部导航 -->
    <!-- <headers></headers> -->
    <!-- banner图 -->
    <div class="banner">
      <img
        src="../../static/img/banner@2x.png"
        alt=""
      >
    </div>
    <!-- 集团概况 -->
    <div class="jtgk cent">
      <div class="title">
        <p class="blue"> <span class="xian"></span><span class="title_txt">集团概况</span></p>
        <p class="gengduo" @click="$router.push({path:'/group'})">查看更多 <i></i></p>
      </div>
      <div class="jt_cont">
           <mt-swipe :auto="3000">
            <mt-swipe-item v-for="(item,i) in jtgkData" :key="i">
                <div class="autoImg" @click="$router.push({path:item.path})">
                    <img class="bigImg" :src="item.img" alt="" >
                    <div class="left">
                        <p class="jt_title">{{item.title}}</p>
                        <p class="texthidden" style=" -webkit-box-orient: vertical;">{{item.cont}}</p>
                    </div>
                    <div class="right">
                        <img src="../../static/img/箭头@2x.png" alt="">
                    </div>
                </div>
            </mt-swipe-item>
          </mt-swipe>
      </div>
    </div>
    <!-- 产品介绍 -->
    <div class="cpjs cent">
      <div class="title">
        <p class="blue"> <span class="xian"></span><span class="title_txt">产品介绍</span></p>
        <p class="gengduo" @click="$router.push({path:'/products'})">查看更多 <i></i></p>
      </div>
      <div class="jt_cont">
       
        <swiper :options="swiperOption" class="swiper-no-swiping">
          <swiper-slide >
            <img id="8" src="../../static/img/飞猪保险@2x.png" alt="" @click="$router.push({path:'/fzproducts?id=8'})">
          </swiper-slide>
          <swiper-slide>
            <img id="4" src="../../static/img/利车保@2x.png" alt="" @click="$router.push({path:'/fzproducts?id=4'})">
          </swiper-slide>
          <swiper-slide>
            <img id="1" src="../../static/img/热保@2x.png" alt="" @click="$router.push({path:'/fzproducts?id=0'})">
          </swiper-slide>
          <swiper-slide>
            <img id="2" src="../../static/img/小二@2x.png" alt="" @click="$router.push({path:'/fzproducts?id=2'})">
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev" style="top: 90%"></div>
          <div class="swiper-button-next" slot="button-next" style="top: 90%"></div>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <div class="zhuanye">
          <p>专业的移动车险服务</p>
          <p>· 方便 · 快捷 · 安全</p>
          <img class="imgs" src="../../static/img/箭头@2x.png" alt="">
        </div>
      </div>
    </div>
    <!-- 最新新闻 -->
    <div class="zxnew cent">
      <div class="title">
        <p class="blue"> <span class="xian"></span><span class="title_txt">最新新闻</span></p>
        <p
          class="gengduo"
          @click="$router.push({path:'/culture'})"
        >查看更多 <i></i></p>
      </div>
      <div class="jt_cont">
        <img src="../../static/img/热烈庆祝北京飞猪科技@2x.png" alt="">
        <div class="new_txt" @click="$router.push({path:'/newDetails?id=0'})">
          <h4>热烈庆祝北京飞猪科技获得了“中关村高新技术企业”证书</h4>
          <p >2018-12-18</p>
        </div>
        <div class="new_txt" @click="$router.push({path:'/newDetails?id=1'})">
          <div class="left">
            <span>2018</span>
            <span>11-08</span>
          </div>
          <div class="right">
            <h4>北京飞猪科技董事长出席金融峰会并在当地调研</h4>
            <p>2018年11月6日-7日，集团公司董事长一行出席战略性互联互通示范项目金融峰会并在当地调研，期间分别拜会了市委书记和政府市长。</p>
          </div>
        </div>
        <div class="new_txt" @click="$router.push({path:'/newDetails?id=2'})">
          <div class="left">
            <span>2018</span>
            <span>08-14</span>
          </div>
          <div class="right">
            <h4>北京飞猪科技在上海分公司召开第二季度会议</h4>
            <p>8月14日，以“新起点、新高度，中国人力资源服务业回望与前瞻”为主题的第四届中国人力资源服务战略发展大会在北京隆重举办。</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部信息 -->
    <!-- <footers></footers> -->
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import headers from "../components/Header.vue";
import footers from "../components/Footers.vue";
export default {
  components: {
    headers,
    footers,
    swiper,
    swiperSlide
  },
  data() {
    let vm = this;
    return {
      num: "01",
      popupVisible: false,
      swiperOption: {
        slidesPerView: 2,
        spaceBetween: 30,
        loop: false,
        delay: 16,
        controller: true,
        // autoplay: true,
        // autoplayStopOnLast: true,
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true
        // },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      jtgkData:[
          {
              img: require('../../static/img/FESCO@2x.png'),
              title: 'FESCO',
              cont: '北京外企人力资源服务有限公司（FESCO）成立于1979年，是开创中国人力资源服务行业的第一家企业，在业界最具竞争力和品牌价值，荣膺中国500强企业。',
              path: '/group?#fescoAdd'
          },
          {
            img: require('../../static/img/联合医务@2x.png'),
              title: '联合医务',
              cont: '香港周大福旗下企业，香港主板上市公司（HK00722）联合医务集团有限公司 (UMP) 由多位资深医生管理，并由专业医护团队参与日常运营，致力于通过旗下诊所网络为不同社区提供多元化的医疗保健服务。',
              path: '/group?#lhywAdd'
          },
          {
              img: require('../../static/img/方胜磐石@2x.png'),
              title: '台湾磐石',
              cont: '磐石金控集团从2003年成立以来，以六个阶段的成长计划，展开全球化布局战略，两岸实力雄厚的战略伙伴及股东群不断投入丰富的在地资源。',
              path: '/group?#fsAdd'
          }
      ]

    }
  },
  mounted() {
     if (this.isMobile()) {
          this.$router.push({ path: "/homes" });
        } else {
          this.$router.push({ path: "/logo" });
        }

  },
  methods: {
    isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
    }
  }
};
</script>

<style lang="scss" scoped>
.swiper-pagination {
  position: relative;
}
.swiper-container {
  height: 4.55rem;
  cursor: pointer;
}
.swiper-button-next {
  width: 0.5rem;
  height: 0.4rem;
  right: 2rem;
}
.swiper-button-prev {
  width: 0.5rem;
  height: 0.4rem;
  left: 2rem;
}
.swiper-slide {
  width: 3.2rem;
  img {
    width: 3.2rem;
  }
}
.cent {
  margin: 0 auto;
  width: 92%;
}
.header {
  height: 0.88rem;
  line-height: 0.88rem;
  display: flex;
  justify-content: space-between;
  .logo {
    margin-top: 0.12rem;
    width: 1.48rem;
    height: 0.64rem;
  }
  .more {
    margin-top: 0.25rem;
    width: 0.36rem;
    height: 0.29rem;
  }
}
.banner {
  width: 100%;
  height: 3.4rem;
  img {
    width: 100%;
    height: 100%;
  }
}
.jtgk {
  height: 5.9rem;
  border-bottom: 0.1rem solid #fafafa;
  .title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0.3rem 0;
    .blue {
      width: 1.8rem;
      color: #004b9e;
      font-size: 0.28rem;
      padding-left: 0.2rem;
      .title_txt {
        padding-left: 0.2rem;
      }
      .xian {
        background-color: #004b9e;
        width: 0.06rem;
        height: 0.28rem;
        border-radius: 0.02rem;
        display: inline-block;
      }
    }
    .gengduo {
      color: #999999;
      i {
        display: inline-block;
        width: 0;
        height: 0;
        border-top: 0.1rem solid transparent;
        border-left: 0.15rem solid #9f9f9f;
        border-bottom: 0.1rem solid transparent;
      }
    }
  }
  .jt_cont {
    height: 5rem;
    .autoImg {
      .jt_title {
        color: #d12028;
        padding: 0.2rem 0;
      }
      p {
        font-size: 0.24rem;

      }

      .bigImg {
        width: 100%;
        height: 3rem;
      }
      .left {
        float: left;
        width: 3.75rem;
        .texthidden{
          width: 100%;
          display: -webkit-box;
         
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .right {
        float: right;
        img {
          margin-top: 0.6rem;
        }
      }
    }
  }
}
.cpjs {
  height: 5.9rem;
  border-bottom: 0.1rem solid #fafafa;
  position: relative;
  .title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0.3rem 0;
    .blue {
      width: 1.8rem;
      color: #004b9e;
      font-size: 0.28rem;
      padding-left: 0.2rem;
      .title_txt {
        padding-left: 0.2rem;
      }
      .xian {
        background-color: #004b9e;
        width: 0.06rem;
        height: 0.28rem;
        border-radius: 0.02rem;
        display: inline-block;
      }
    }
    .gengduo {
      color: #999999;
      i {
        display: inline-block;
        width: 0;
        height: 0;
        border-top: 0.1rem solid transparent;
        border-left: 0.15rem solid #9f9f9f;
        border-bottom: 0.1rem solid transparent;
      }
    }
  }
  .jt_cont {
    .imgs {
      width: 100%;
      display: flex;
      overflow: scroll;
      img {
        display: inline-block;
        width: 3.2rem;
        height: 1.8rem;
        margin: 0.3rem 0;
        margin-left: 0.1rem;
      }
    }
    .zhuanye {
      position: relative;
      top: -2.1rem;
      p {
        color: #d82936;
        font-size: 0.28rem;
        line-height: 0.48rem;
      }
      .imgs {
        position: absolute;
        right: 0;
        width: 0.3rem;
        height: 0.3rem;
        top: 0.5rem;
      }
    }
  }
  .lcNext {
    position: absolute;
    bottom: 0.2rem;
    width: 2.5rem;
    height: 0.32rem;
    left: 50%;
    transform: translateX(-50%);
    img {
      display: inline-block;
      margin: 0 0.5rem;
      width: 0.14rem;
      height: 0.26rem;
    }
  }
}
.zxnew {
  border-bottom: 0.1rem solid #fafafa;
  .title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0.4rem 0;
    .blue {
      width: 1.8rem;
      color: #004b9e;
      font-size: 0.28rem;
      padding-left: 0.2rem;
      .title_txt {
        padding-left: 0.2rem;
      }
      .xian {
        background-color: #004b9e;
        width: 0.06rem;
        height: 0.28rem;
        border-radius: 0.02rem;
        display: inline-block;
      }
    }
    .gengduo {
      color: #999999;
      i {
        display: inline-block;
        width: 0;
        height: 0;
        border-top: 0.1rem solid transparent;
        border-left: 0.15rem solid #9f9f9f;
        border-bottom: 0.1rem solid transparent;
      }
    }
  }
  .jt_cont {
    img {
      width: 100%;
      height: 100%;
      margin: 0.15rem 0;
    }
    .new_txt {
      font-size: 0.26rem;
      color: #9e9fa3;
      height: 0.9rem;
      margin: 0.2rem 0;
      h4 {
        // height: 0.36rem;
        color: #333333;
        line-height: 0.36rem;
      }
      p {
        font-size: 0.22rem;
      }
      .left {
        float: left;
        width: 0.85rem;
        text-align: left;
        border-right: 2px solid #cacaca;
        // padding-right:.1rem;
        span {
          width: 0.9rem;
          display: inline-block;
          font-size: 0.18rem;
          color: #868992;
        }
        span:nth-child(1) {
          color: #323232;
          font-size: 0.24rem;
        }
      }
      .right {
        float: left;
        padding-left: 0.1rem;
        h4 {
          font-size: 0.28rem;
        }
        p {
          color: #868992;
          width: 5.4rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 0.24rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Homes.vue